// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCXlmwRWIG9FsmZwuu8YXI7HaDpU051fbA',
    authDomain: 'knowhow-giganten.firebaseapp.com',
    databaseURL: 'https://knowhow-giganten.firebaseio.com',
    projectId: 'knowhow-giganten',
    storageBucket: 'knowhow-giganten.appspot.com',
    messagingSenderId: '917670458315',
    appId: '1:917670458315:web:bbbde36cfcc60277037c4e',
    measurementId: 'G-XG497SXCTM'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
